import React, { Component } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import Constants from 'common/constants'
import Utils from 'common/utils'
import CommonComponents from 'components/commonComponents'
import Theme from 'common/theme'
import NativeAgent from 'common/nativeAgent'

export default class LocationPickerView extends Component {
    handleBackPress(e) {
        e.preventDefault();
        // this.props.history.goBack();
        if (false === Utils.isNull(this.props.back_press_callback)) {
            this.props.back_press_callback()
        }
    }

    getBackBtnHtml() {
        if (
            (
                Utils.isNull(this.props.location) === false &&
                Utils.isNull(this.props.location.state) === false &&
                Utils.isNull(this.props.location.state.isBackEnabled) === false &&
                this.props.location.state.isBackEnabled === true
            ) ||
            (
                Utils.isNull(this.props.is_back_enabled) === false &&
                this.props.is_back_enabled
            )
        ) {
            return (
                <button onClick={this.handleBackPress.bind(this)} className="location-picker-back-container">
                    <img src={Theme.getThemeBackBtnForLocationPicker()} width="40px" height="40px" alt="" />
                </button>
            )
        }
        return (<span></span>)
    }

    componentDidMount() {
        try {
            // Have to remove all the other themes before adding this
            document.body.classList.remove(...Theme.getAllThemesBodyClasses())
            document.body.classList.add(Theme.getThemeBodyClass());
        } catch (e) {
            console.log("Error applying theme for body")
        }
        this.componentIsDisplayed()
    }

    componentIsDisplayed() {
        console.log("DISPLAY: location is displayed")

        // Add refresh handler
        CommonComponents.AddWindowRefreshHandler(this.weatherRefreshHandler.bind(this))

        // Call the native agent 
        NativeAgent.addBlackListBounds("")
    }

    weatherRefreshHandler() {
        if (false === Utils.isNull(this.props.refresh_handler_cb)) {
            this.props.refresh_handler_cb()
            return
        }
        // Fallback to default handler
        CommonComponents.DefaultRefreshHandler()
    }

    getLocationPickerBg() {
        return (
            <img src={Theme.getThemeLocationPickerBgImage()} className="location-picker-img" alt="" />
        )
    }

    render() {
        console.log("INNER-WIDTH : " + window.innerWidth);
        console.log("INNER-HEIGHT: " + window.innerHeight);
        return (
            <ReactCSSTransitionGroup
                transitionName="fade-in"
                transitionEnter={false}
                transitionLeave={false}
                transitionAppear={true}
                transitionAppearTimeout={Constants.FADE_IN_TRANSITION_TIMEOUT}
            >
                <div className={Theme.getThemeBaseClass()}>
                    <div className="location-top-bar"></div>
                    {this.getBackBtnHtml()}
                    <div key="location-picker-top" className="location-picker-container">
                        <div className="location-img-container">
                            {this.getLocationPickerBg()}
                        </div>
                        <div className="location-bottom-container">
                            <div className="location-bottom-text">
                                Choose Your Location
                            </div>
                            <div className="detect-location-container">
                                <a href="inapp://location/detect" className="btn-bottom">Detect Location</a>
                            </div>
                            <div className="pick-location-container">
                                <a href="inapp://location/pick" className="btn-bottom">Select Location</a>
                            </div>
                        </div>
                    </div>
                    {CommonComponents.getBottomBarComponents()}
                </div>
            </ReactCSSTransitionGroup>
        )
    }
}

LocationPickerView.defaultProps = {
    back_press_callback: null
}


// WEBPACK FOOTER //
// ./src/components/locationPickerView.js